import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class TokenInterceptor implements HttpInterceptor {
  userData: any;
  constructor() {}
  intercept(request: HttpRequest<any>, next: HttpHandler): any {
    // if (localStorage.getItem("token")) {
    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${localStorage.getItem("token")}`,
    //     },
    //   });
    // }

    return next.handle(request).pipe(
      catchError((error: any): any => {
        if (error && error.status == 500) {
        } else if (error && error.status == 401) {
        } else if (error && error.error && error.error.message) {
          if (typeof error.error.message === "string") {
          }
        }
        return throwError(error);
      })
    );
  }
}
